import * as React from 'react'
import {
    Button, Dialog, DialogTitle, DialogContent, DialogActions, Divider
} from '@mui/material';


const ViewHTMLPreview = ({ previewHtml, previewOpen, setPreviewOpen, handleConfirm = null, setIsEditData }) => {
    return (
        <Dialog
            open={previewOpen}
            onClose={() => {
                setPreviewOpen(false)
                setIsEditData(null)
            }}
            fullWidth
            maxWidth="lg"
        >
            <DialogTitle>Preview </DialogTitle>
            <DialogContent>
                <iframe
                    srcDoc={previewHtml}
                    title="QC Parameters Preview"
                    style={{
                        width: '100%',
                        minHeight: '400px',
                        border: '1px solid #ddd',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '4px'
                    }}
                />
            </DialogContent>
            <Divider />
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={() => {
                    setPreviewOpen(false)
                    setIsEditData(null)
                }} color="error" variant="outlined">
                    Close Preview
                </Button>
                {handleConfirm && (
                    <>
                        <Button onClick={() => handleConfirm('save')} color="primary" variant="contained">
                            Save Configuration
                        </Button>
                        <Button onClick={() => handleConfirm('sendMail')} color="primary" variant="contained">
                            Save and Send Mail to ClickPost
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    )
}


export default ViewHTMLPreview;